<template>
    <div>
        <media-chooser
            :value="image"
            label="Image"
            type="image"
            @input="onImageChange"
        />
        <form v-if="alignmentOption" class="row col-12">
            Image alignment:
            <div v-for="(option, index) in options" :key="index">
                <input
                    v-model="imageAlignment"
                    type="radio"
                    name="alignment"
                    :value="option.value"
                    class="ml-2"
                />
                {{ option.text }}
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        alignmentOption: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            image: {},
            imageAlignment: 'center',
            options: [
                { value: 'left', text: 'Left' },
                { value: 'center', text: 'Center' },
                { value: 'right', text: 'Right' }
            ]
        };
    },

    watch: {
        imageAlignment() {
            this.image.alignment = this.imageAlignment;

            this.$emit('input', this.image);
        }
    },

    mounted() {
        this.image = { ...this.value };
        this.imageAlignment = this.image.alignment || 'center';
    },

    methods: {
        onImageChange(image) {
            this.image = { ...image };
            this.image.alignment = this.imageAlignment;

            this.$emit('input', this.image);
        }
    }
};
</script>
